import { cn } from "@/lib/utils";
import { ElementType, ReactNode } from "react";

interface PageTopProps {
  children: ReactNode;
  className?: string;
  as?: ElementType;
  padX?: boolean;
  padBottom?: boolean;
}

const PageTop = ({
  children,
  className,
  as: Tag = "section",
  padX = true,
  padBottom = true,
}: PageTopProps) => (
  <Tag
    className={cn(
      "pt-40 md:pt-52",
      padBottom && "pb-20 md:pb-28",
      padX && "px-6 md:px-10",
      className,
    )}
  >
    {children}
  </Tag>
);

export default PageTop;
